const DEFAULT_API_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.destinatarium.com/api/v1"
    : "http://localhost:3000/api/v1";

export const API_URL = (
  process.env.VUE_APP_API_URL || DEFAULT_API_URL
).replace(/\/+$/, "");
